<div class="frame-1">
  <div class="frame-4">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="40"
      width="43"
      viewBox="0 0 576 512"
      class="success-details"
    >
      <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
      <path
        fill="#ff0f0f"
        d="M569.5 440C588 472 564.8 512 527.9 512H48.1c-36.9 0-60-40.1-41.6-72L246.4 24c18.5-32 64.7-32 83.2 0l239.9 416zM288 354c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46zm-43.7-165.3l7.4 136c.3 6.4 5.6 11.3 12 11.3h48.5c6.4 0 11.6-5 12-11.3l7.4-136c.4-6.9-5.1-12.7-12-12.7h-63.4c-6.9 0-12.4 5.8-12 12.7z"
      />
    </svg>
    <div class="text-wrapper-4">Reset Failed</div>
    <p class="success-details">
      There was an issue resetting your password, please try again.
    </p>
    <p class="no-email">
      <a (click)="toggleIsClicked()">Reset password?</a>
    </p>
  </div>
</div>
